import { Component, Inject, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterOperatorType } from 'app/shared/models/filter-operator-type.model';
import { MapFilterItem } from '../../map-filter-state.model';
import {
  ACTIVE_FILTERS_ON_MAP_MANAGER,
  MapFilterManager,
} from '../../map-filter.manager';

@Component({
  selector: 'app-floating-filter',
  templateUrl: 'floating-filter.component.html',
  styleUrls: ['floating-filter.component.scss'],
})
export class FloatingFilterComponent implements OnInit {
  @Input()
  fields: __esri.Field[];

  filtersObservable: Observable<MapFilterItem[]>;

  filterTypeEq = FilterOperatorType.Eq;

  constructor(
    @Inject(ACTIVE_FILTERS_ON_MAP_MANAGER)
    private activeFiltersOnMapManager: MapFilterManager
  ) {}

  ngOnInit(): void {
    this.filtersObservable = this.activeFiltersOnMapManager.onFiltersChanged;
  }

  onBtnRemoveFiltersClick() {
    this.activeFiltersOnMapManager.removeAllFilters();
  }
}
